var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialXLtr = function SvgSocialXLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.561 15.102h11.506l-25.13 28.715L88.5 82.898H65.358L47.219 59.202l-20.73 23.696H14.967l26.874-30.72L13.5 15.102h23.729L53.608 36.76zM68.52 76.02h6.372l-41.134-54.4h-6.845z"
  })));
};
export default SvgSocialXLtr;